<template>
	<div>
		<div class="row">
			<div class="col-md-1 col">Вид отчёта</div>
			<div class="col-md-3 col">
				<select class='form-control my-control' v-model='type'>
					<option v-for='report in reportsList' :value='report.id' :key='report.id'>{{ report.name }}</option>
				</select>
			</div>
			<template v-if="type == 12"> 
				<div class="col-md-1 col">Период</div>
				<span class='col-md-1'>
					<select class='form-control my-control' v-model="year" @input='yearChange'>
						<option value="2018">2018</option>
						<option value="2019">2019</option>
						<option value="2020">2020</option>
						<option value="2021">2021</option>
						<option value="2022">2022</option>
						<option value="2023">2023</option>
						<option value="2024">2024</option>
						<option value="2025">2025</option>
						<option value="2026">2026</option>
					</select>
				</span>
			</template>
			<template v-else>
				<div class="col-md-1 col">Период</div>
				<span class='col-md-1' style='width: 30px;'>
					с
				</span>
				<div class="col-md-1 col">
					<datepicker
							@input='startChange'
							v-model='start'
							format='dd.MM.yyyy'
							class='dp-control'
							:disabled='disableDate'
						></datepicker>	
				</div>
				<span class='col-md-1' style='width: 30px;'>
					до
				</span>
				<div class="col-md-1 col">
					<datepicker
						@input='endChange'
						v-model='end'
						format='dd.MM.yyyy'
						class='dp-control'
						:disabled='disableDate'
					></datepicker>	
				</div>
			</template>
			<div class="col-md-3 pull-right">
				<input type='button' class='btn btn-secondary' @click.prevent="close" value='Отмена'></input>
				<input type='button' class='btn btn-primary' @click.prevent='save' value='Сохранить'></input>
				<input type='button' class='btn btn-primary' @click.prevent='view' value='Сформировать' :disabled='disableView'></input>
			</div>
		</div>
		<regions-list v-if='displayRegionsList'></regions-list>
		<fo-list v-if='displayFoList' :all="displaySelectAllFOs"></fo-list>
		<router-view :start='start' :end='end' :regions='regions' :year='year' v-if='!disableView'></router-view>
	</div>
</template>

<script>
	import router from '../../router'
	import { datepicker } from 'vue-strap'
	import moment from 'moment'
	import {DB} from './../../constants'
	import { EventBus } from '../../lib/EventBus'
	import RegionsList from './RegionsList'
	import FoList from './FoList'

	const REPORT_WEEK = 'report_week.php'
	const REPORT_CONCLUSION = 'report_conclusion.php'
	const REPORT_SOM = 'report_som.php'
	const REPORT_MONITORING_RLH = 'report_monitoring_rlh.php'
	const REPORT_NPA_MZL = 'report_npa_mzl.php'
	const REPORT_DLH_FO = 'report_dlh.php'
	const REPORT_WARRANTS_COUNT = 'report_warrants_count.php'
	const REPORT_ACTS_AND_CONCLUSIONS_COUNT = 'report_acts_and_conclusions_count.php'
	const REPORT_ACTS_LPO = 'report_acts_lpo.php'
	const REPORT_STAT = 'report_stat.php'
	const REPORT_STAT_LPO = 'report_stat_lpo.php'

	const REPORT_WEEK_V2 = 'report_week_v2.php'
	const REPORT_CONCLUSION_V2 = 'report_conclusion_v2.php'
	const REPORT_SOM_V2 = 'report_som_v2.php'
	const REPORT_MONITORING_RLH_V2 = 'report_monitoring_rlh_v2.php'
	const REPORT_DLH_FO_V2 = 'report_dlh_v2.php'
	const REPORT_DLH_FO_V3 = 'report_dlh_v3.php'
	const REPORT_MOVING = 'report_moving.php'
	const REPORT_ACTS_COUNT = 'report_acts_count.php'
	const REPORT_DLH_7 = 'report_dlh_7.php'

	export default {
		name: 'reports',
		data: function () {
			return {
				start: moment().subtract(7,'days').format('DD.MM.YYYY'),
				end: moment().format('DD.MM.YYYY'),
				type: '0',
				regions: [],
				fo: null,
				year: 2026
			}
		},
		components: {
			datepicker,
			RegionsList,
			FoList
		},
		computed: {
			displayRegionsList () {
				return this.type == 5 || this.type == 10
			},
			displayFoList () {
				return this.type == 7 || this.type == 17 || this.type == 18 || this.type == 22
			},
			displaySelectAllFOs() {
				return this.type == 22
			},
			reportsList () {
				return this.$parent.reports.filter(e => {
					return e.id != 6
				})
			},
			disableView () {
				let found = this.$parent.reports.find(e => {
					return e.id == this.type
				}) 
				return found ? found.print_only == 't' : false
			},
			disableDate () {
				return this.type == 9
			}
		},
		methods: {
			close () {
				router.replace('/main')
			},
			save () {
				let joined = 'null'
				let report_name = 'Российская Федерация'

				switch (this.type) {
					case '1':
						window.location.href=`${DB}${REPORT_WEEK}?start_date=${this.start}&end_date=${this.end}`
						break
					case '2':
						window.location.href=`${DB}${REPORT_CONCLUSION}?start_date=${this.start}&end_date=${this.end}`
						break
					case '3':
						window.location.href=`${DB}${REPORT_SOM}?start_date=${this.start}&end_date=${this.end}`
						break
					case '4':
						window.location.href=`${DB}${REPORT_MONITORING_RLH}?start_date=${this.start}&end_date=${this.end}`
						break
					case '5':
						if(this.regions.length)
							joined = '{' + this.regions.map(e => {return e.id}).join(',') + '}'

						if(this.fo && this.fo.id != 0)
							if(this.regions.length > 1)
								report_name = this.fo.name

						if(this.regions.length == 1)
								report_name = this.regions[0].name

						window.location.href=`${DB}${REPORT_NPA_MZL}?start_date=${this.start}&end_date=${this.end}&name=${report_name}&regions=${joined}`
						break
					case '7':
						window.location.href=`${DB}${REPORT_DLH_FO}?start_date=${this.start}&end_date=${this.end}&fo_id=${this.fo.id}`
						break
					case '8':
						window.location.href=`${DB}${REPORT_WARRANTS_COUNT}?start_date=${this.start}&end_date=${this.end}`
						break
					case '9':
						window.location.href=`${DB}${REPORT_ACTS_AND_CONCLUSIONS_COUNT}`
						break
					case '10':
						if(this.regions.length)
							joined = this.regions.map(e => {return e.id}).join(',')
						
						if(this.fo && this.fo.id != 0)
							if(this.regions.length > 1)
								report_name = this.fo.name

						if(this.regions.length == 1)
								report_name = this.regions[0].name

						window.location.href=`${DB}${REPORT_ACTS_LPO}?start_date=${this.start}&end_date=${this.end}&name=${report_name}&regions=${joined}`
						break
					case '11':
						window.location.href=`${DB}${REPORT_STAT}?start_date=${this.start}&end_date=${this.end}`
						break
					case '12':
						window.location.href=`${DB}${REPORT_STAT_LPO}?year=${this.year}`
						break
					//v2
					case '13':
						window.location.href=`${DB}${REPORT_WEEK_V2}?start_date=${this.start}&end_date=${this.end}`
						break
					case '14':
						window.location.href=`${DB}${REPORT_CONCLUSION_V2}?start_date=${this.start}&end_date=${this.end}`
						break
					case '15':
						window.location.href=`${DB}${REPORT_SOM_V2}?start_date=${this.start}&end_date=${this.end}`
						break
					case '16':
						window.location.href=`${DB}${REPORT_MONITORING_RLH_V2}?start_date=${this.start}&end_date=${this.end}`
						break
					case '17':
						window.location.href=`${DB}${REPORT_DLH_FO_V2}?start_date=${this.start}&end_date=${this.end}&fo_id=${this.fo.id}`
						break
					case '18':
						window.location.href=`${DB}${REPORT_DLH_FO_V3}?start_date=${this.start}&end_date=${this.end}&fo_id=${this.fo.id}`
						break
					case '19':
						window.location.href=`${DB}${REPORT_MOVING}?start_date=${this.start}&end_date=${this.end}`
						break
					case '21':
						window.location.href=`${DB}${REPORT_ACTS_COUNT}?start_date=${this.start}&end_date=${this.end}`
						break
					case '22':
						window.location.href=`${DB}${REPORT_DLH_7}?start_date=${this.start}&end_date=${this.end}&fo_id=${this.fo.id}`
						break
					default:
						break
				}
			},
			view () {
				switch (this.type) {
					case '1':
						router.replace('/main/reports/monitoring')
						break
					case '2':
						router.replace('/main/reports/conclusion')
						break
					case '3':
						router.replace('/main/reports/mzl')
						break
					case '4':
						router.replace('/main/reports/monitoring-rlh')
						break
					case '5':
						router.replace('/main/reports/npa-mzl')
						break
					case '8':
						router.replace('/main/reports/warrants-count')
						break
					case '11':
						router.replace('/main/reports/stat')
						break
					case '12':
						router.replace('/main/reports/stat_lpo')
						break
					//v2
					case '13':
						router.replace('/main/reports/monitoring-v2')
						break
					case '14':
						router.replace('/main/reports/conclusion-v2')
						break
					case '15':
						router.replace('/main/reports/mzl-v2')
						break
					case '16':
						router.replace('/main/reports/monitoring-rlh-v2')
						break
					default:
						break
				}
				
			},
			startChange (e) {
				let date = {}
				date.start = e
				date.end = this.end
				EventBus.$emit('monitoring-date', date)
				EventBus.$emit('monitoring-rlh-date', date)
				EventBus.$emit('conclusion-date', date)
				EventBus.$emit('mzl-date', date)
				EventBus.$emit('report-date', date)
				EventBus.$emit('npa-mzl-data', {start: e, end: this.end, regions: this.regions})
				EventBus.$emit('stat-date', date)
			},
			endChange (e) {
				let date = {}
				date.start = this.start
				date.end = e
				EventBus.$emit('monitoring-date', date)
				EventBus.$emit('monitoring-rlh-date', date)
				EventBus.$emit('conclusion-date', date)
				EventBus.$emit('mzl-date', date)
				EventBus.$emit('report-date', date)
				EventBus.$emit('npa-mzl-data', {start: this.start, end: e, regions: this.regions})
				EventBus.$emit('stat-date', date)
			},
			yearChange (e) {
				EventBus.$emit('stat-lpo-date', {year: e.target.value})
			}
		},
		created () {
			if(this.$parent.reports.length)
				this.type = this.$parent.reports[0].id
			else
				router.replace('/main')

			EventBus.$on('change_regions', (data) => {
				this.regions = data
				EventBus.$emit('npa-mzl-data', {start: this.start, end: this.end, regions: this.regions})
			})

			EventBus.$on('change_fo', (data) => {
				this.fo = data
			})
		},
		beforeDestroy() {
			EventBus.$off('change_regions')
			EventBus.$off('change_fo')
		}
	}
</script>

<style>
	.dp-control > input.form-control {
		padding-left: 5px;
		height: 24px;
		font-size: 12px;
		display: inline-table;
	}
</style>



// WEBPACK FOOTER //
// Reports.vue?fb86292a